import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { clearRecoveryCodes, getRecoveryCodes } from './recovery-store';

/** A clean page to print. The codes only live in memory, so a reload forgets them. */
export function RecoveryPrintPage() {
  const [codes] = useState(getRecoveryCodes);

  return (
    <main className="page print-page">
      <h1>Personal OS recovery codes</h1>
      {codes ? (
        <>
          <p>
            Each code works <strong>once</strong>. Keep this page somewhere safe.
          </p>
          <ol className="codes print-codes">
            {codes.map((code) => (
              <li key={code}>
                <code>{code}</code>
              </li>
            ))}
          </ol>
          <div className="no-print button-row">
            <button type="button" className="primary" onClick={() => window.print()}>
              Print
            </button>
            <Link to="/account" onClick={clearRecoveryCodes}>
              Back to account
            </Link>
          </div>
        </>
      ) : (
        <>
          <p role="status">
            These codes aren't available any more. They're only shown once, right after they're
            made. You can make a new set from your account page.
          </p>
          <Link to="/account">Back to account</Link>
        </>
      )}
    </main>
  );
}
